var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-block z-1"},[_c('IncomingPayments',{attrs:{"projectId":_vm.id}})],1),_c('div',{staticClass:"card-block"},[_c('Invoices',{attrs:{"projectId":_vm.id}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }